import register from '../../../../global/js/registry';
export default register('m-formstep-select-icon', () => import(/* webpackMode: "lazy" */ './m-formstep-select-icon.controller'));
